<template>
  <div class="createUser-dialog">
    <gs-modal
      v-model="visible"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :has-form="true"
      class="createUser-dialog-modal"
      title="新建-用户"
      @cancel="close"
      @close="close"
      @confirm="handleConfirm"
    >
      <div class="page-form">
        <gs-form
          ref="form"
          :model="form"
          class="form"
          label-width="50px"
          label-position="left"
          gap="small"
        >
          <gs-form-item
            label="用户名:"
            prop="username"
            class="form-item-username"
          >
            <gs-input
              ref="nameInput"
              v-model="form.username"
              type="text"
            />
          </gs-form-item>
        </gs-form>
      </div>
    </gs-modal>
  </div>
</template>
<script>
import service from '../../service/authorityService.js'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  data() {
    return {
      form: {
        username: '',
        parentId:localStorage.getItem("userId")
      }
    }
  },
  mounted() {
  },
  computed: {
    ...mapState({
      visible: 'createUserShow'
    })
  },
  watch: {
    visible() {
      if (this.visible) {
        this.form.username = ''
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
      }
    }
  },
  methods: {
    ...mapMutations({
      close: 'CREATE_USER_HIDE',
      needReload: 'NEED_RELOAD_TREE'
    }),
    handleConfirm() {
      let obj = {
        username: this.form.username,
        parentId:localStorage.getItem("userId")
      }
      service.saveUser(obj).then(res => {
        this.$Message.success('创建用户成功!')
        this.form.username = ''
        this.close()
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    beforeConfirm(e, done) {
      if (this.form.username === null || this.form.username === '') {
        this.$Message.warning('用户名不能为空')
        return
      }
      done()
    },
    beforeClose(e, done) {
      // done(false)可以阻止modal关闭
      this.form.username = ''
      this.close()
    }
  }
}
</script>
<style lang="scss" scoped>
.createUser-dialog {
  &-modal {
    .page-form {
      .title {
        color: #0073e8;
        margin-bottom: 12px;
      }
      .gs-form-item {
        margin-bottom: 12px;
      }
      .button {
        float: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/authority/createUser.vue